import { useState } from 'react';
import { TextField } from '@recargas-dominicanas/core/components';
import { useForm } from '../../../utils/useForm';
import { Modal } from '../../../components/modal/modal.component';
import { useBusinessListStore } from '../../../stores/businessListStore';
import { BusinessApi } from '../../../api/business.api';
import { emptyToUndefine } from '../../../utils/emptyToUndefine';
import { style } from './add-business-modal.module.css';
import type { IBusiness } from '@recargas-dominicanas/core/types';

interface Props {
  open: boolean;
  onAdded: (business: IBusiness) => void;
  onClose: () => void;
}

export function AddBusinessModal(props: Props) {

  const { open, onAdded, onClose } = props;

  const businessListStore = useBusinessListStore();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  
  const form = useForm({
    name: '',
    rnc: { value: '', optional: true },
    phone: { value: '', optional: true },
    email: { value: '', optional: true },
    city: '',
    address: ''
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      setLoading(true);

      const business = await BusinessApi.add({
        name: form.name.value,
        rnc: emptyToUndefine(form.rnc.value),
        phone: emptyToUndefine(form.phone.value),
        email: emptyToUndefine(form.email.value),
        city: form.city.value,
        address: form.address.value
      });

      await businessListStore.fetch();

      setLoading(false);
      onAdded(business);
      handleClose();

    } catch {

      setLoading(false);
      setError('Error agregando negocio');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Agregar negocio'
      style={style.modal}
      secondaryButton='Guardar'
      disabledSecondaryButton={loading}
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <TextField 
        style={style.textField}
        label='Nombre'
        value={form.name.value}
        error={form.name.error}
        onChange={form.name.onChange}
        onBlur={form.name.onBlur}/>
      <TextField 
        style={style.textField}
        label='RNC (opcional)'
        value={form.rnc.value}
        error={form.rnc.error}
        onChange={form.rnc.onChange}
        onBlur={form.rnc.onBlur}/>
      <TextField 
        style={style.textField}
        label='Teléfono (opcional)'
        value={form.phone.value}
        error={form.phone.error}
        onChange={form.phone.onChange}
        onBlur={form.phone.onBlur}/>
      <TextField 
        style={style.textField}
        label='Email (opcional)'
        value={form.email.value}
        error={form.email.error}
        onChange={form.email.onChange}
        onBlur={form.email.onBlur}/>
      <TextField 
        style={style.textField}
        label='Ciudad'
        value={form.city.value}
        error={form.city.error}
        onChange={form.city.onChange}
        onBlur={form.city.onBlur}/>
      <TextField 
        style={style.textField}
        label='Dirección'
        value={form.address.value}
        error={form.address.error}
        onChange={form.address.onChange}
        onBlur={form.address.onBlur}/>
    </Modal>
  );
}
